module.exports = __webpack_public_path__ + "img/side-entrance.053bd3f2.webp";